import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PlayerAgeFilterModal, PlayerPositionFilterModal } from "app/components";
import { PlayerFilter } from "app/models";
import { CONSTANTS } from '../../constants';

@Component({
    selector: 'players-page',
    templateUrl: './players.page.html',
    styleUrls: ['./players.page.scss'],
})
export class PlayersPage implements OnInit {

    filters: PlayerFilter[] = [];
    positionFilters: PlayerFilter[] = [];
    sideFilters: PlayerFilter[] = [];
    ageFilters: PlayerFilter[] = [];
    
    constructor(private modalService: NgbModal)  {}

    ngOnInit(): void {
        
    }

    
    openPositionFilter() {
        let filters = {
            gk: false,
            sw: false,
            df: false,
            dm: false,
            mf: false,
            am: false,
            fw: false,
            l: false,
            c: false,
            r: false
        }

        this.positionFilters.forEach(item => {
            if (item.filterValue === CONSTANTS.tacticPositions.gk) {
                filters.gk = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.gk) {
                filters.gk = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.df) {
                filters.df = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.dm) {
                filters.dm = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.mf) {
                filters.mf = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.am) {
                filters.am = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.fw) {
                filters.fw = true;
            }
        });

        this.sideFilters.forEach(item => {
            if (item.filterValue === CONSTANTS.playerSides.L) {
                filters.l = true;
            }

            if (item.filterValue === CONSTANTS.playerSides.C) {
                filters.c = true;
            }

            if (item.filterValue === CONSTANTS.playerSides.R) {
                filters.r = true;
            }
        });

        const modalRef = this.modalService.open(PlayerPositionFilterModal);
        
                modalRef.componentInstance.filters = filters;
        
                modalRef.result.then((result: any) => {
                    if (result) {
                        this.rebuildPositionFilter(result);
                        this.rebuildSideFilter(result);
                    }
                }, (reason) => { });
    }

    openAgeFilter() {
        const modalRef = this.modalService.open(PlayerAgeFilterModal);
        
               // modalRef.componentInstance.filters = filters;
        
                modalRef.result.then((result: any) => {
                    if (result) {
                        this.rebuildAgeFilter(result);
                    }
                }, (reason) => { });
    }

    private rebuildFilters() {
        this.filters = [];

        this.filters = [...this.positionFilters, ...this.sideFilters]//, ...arr2, ...arr3];
    }

    private rebuildPositionFilter(filter: any) {
        this.positionFilters = [];

        if (filter.gk) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.gk, CONSTANTS.tacticPositionNames.gk));
        }

        if (filter.sw) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.sw, CONSTANTS.tacticPositionNames.sw));
        }

        if (filter.df) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.df, CONSTANTS.tacticPositionNames.df));
        }

        if (filter.dm) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.dm, CONSTANTS.tacticPositionNames.dm));
        }

        if (filter.mf) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticPositionNames.mf));
        }

         if (filter.am) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.am, CONSTANTS.tacticPositionNames.am));
        }

         if (filter.fw) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.fw, CONSTANTS.tacticPositionNames.fw));
        }

        this.rebuildFilters();
    }

    private rebuildSideFilter(filter: any) {
        this.sideFilters = [];

        if (filter.l) {
            this.sideFilters.push(this.createPlayerSideFilter(CONSTANTS.playerSides.L, "L"));
        }

        if (filter.c) {
            this.sideFilters.push(this.createPlayerSideFilter(CONSTANTS.playerSides.C, "C"));
        }

        if (filter.r) {
            this.sideFilters.push(this.createPlayerSideFilter(CONSTANTS.playerSides.R, "R"));
        }

        this.rebuildFilters();
    }

    private rebuildAgeFilter(filter: any) {
        this.ageFilters = [];

        if (!filter.minAge && !filter.maxAge) {
            this.rebuildFilters();
            return;
        }
/*
        if (filter.minAge === filter.maxAge) {
            this.ageFilters.push(this.createPlayerAgeFilter(CONSTANTS.playerSides.L, "L"));
        }

        if (filter.c) {
            this.sideFilters.push(this.createPlayerSideFilter(CONSTANTS.playerSides.C, "C"));
        }

        if (filter.r) {
            this.sideFilters.push(this.createPlayerSideFilter(CONSTANTS.playerSides.R, "R"));
        }*/

        this.rebuildFilters();
    }

    private createPlayerPositionFilter(pos: number, label: string): PlayerFilter{
            let f = new PlayerFilter();
            f.filterCondition = CONSTANTS.substitutionConditions.equal;
            f.filterType = CONSTANTS.playerFilterTypes.position;
            f.filterValue = pos;
            f.label = label

            return f;
    }

    private createPlayerSideFilter(pos: number, label: string): PlayerFilter{
            let f = new PlayerFilter();
            f.filterCondition = CONSTANTS.substitutionConditions.equal;
            f.filterType = CONSTANTS.playerFilterTypes.side;
            f.filterValue = pos;
            f.label = label

            return f;
    }

    private createPlayerAgeFilter(min: number, max: number): PlayerFilter{

            let f = new PlayerFilter();
           /* f.filterCondition = CONSTANTS.substitutionConditions.equal;
            f.filterType = CONSTANTS.playerFilterTypes.side;
            f.filterValue = pos;
            f.label = label*/

            return f;
    }

    private removeFilter(filter: PlayerFilter) {
        switch(filter.filterType) {
            case CONSTANTS.playerFilterTypes.position:
                this.removePositionFilter(filter);
            case CONSTANTS.playerFilterTypes.side:
                this.removeSideFilter(filter);
        }
    }

    private removePositionFilter(filter: PlayerFilter) {
        
        const index = this.positionFilters.indexOf(filter);

        if (index > -1) {
            this.positionFilters.splice(index, 1); 

            this.rebuildFilters();
        }
    }

    private removeSideFilter(filter: PlayerFilter) {
        
        const index = this.sideFilters.indexOf(filter);

        if (index > -1) {
            this.sideFilters.splice(index, 1); 

            this.rebuildFilters();
        }
    }
}